const TO_SHOW = 5;
const LOW_RATING_THRESHOLD = 4.5;
const HIGHEST_RATING_FILTER = 5;
const REVIEWS_WITH_IMAGES = 7;
// info: sorry for the mess, this is a quick and dirty solution to move the reviews with images to the top of the list
// without building the whole thing from scratch
const moveImageReviews = (tryAgain = true) => {
	const reviewsWrapperWithImages = document.querySelector('#ReviewsWidget-image-source');
	const mainReviewsWrapper = document.querySelector('#ReviewsWidget');
	const dropdownButtonsWithImages = reviewsWrapperWithImages.querySelectorAll('.R-DropUpDownMenu__item');
	// set sorting to highest rating and reviews with images
	// 5 - Highest Rating
	// 7 - Reviews with Images
	dropdownButtonsWithImages.length >= HIGHEST_RATING_FILTER &&
		dropdownButtonsWithImages[HIGHEST_RATING_FILTER]?.click();
	setTimeout(() => {
		const dropdownButtonsWithImages = reviewsWrapperWithImages.querySelectorAll('.R-DropUpDownMenu__item');
		dropdownButtonsWithImages.length >= REVIEWS_WITH_IMAGES && dropdownButtonsWithImages[REVIEWS_WITH_IMAGES]?.click();
	}, 1000);
	setTimeout(() => {
		const mainDropdownButtons = mainReviewsWrapper.querySelectorAll('.R-DropUpDownMenu__item');
		const reviewItems = [...reviewsWrapperWithImages.querySelectorAll('.R-ContentList__item')];
		mainDropdownButtons.length >= HIGHEST_RATING_FILTER && mainDropdownButtons[HIGHEST_RATING_FILTER]?.click();
		// hideOverallRating(mainReviewsWrapper);
		console.log('reviewItems', reviewItems);
		if (reviewItems.length === 0) {
			if (tryAgain) {
				setTimeout(() => {
					moveImageReviews(false);
				}, 3000);
			} else {
				document.querySelector('#reviews-io-polaris-modal-ReviewsWidgetimagesource .ElementsWidget')?.remove();
				reviewsWrapperWithImages.remove();
				return;
			}
		}
		if (reviewItems.length === 1) {
			// This is a special case.
			// If it is just one picture review, it looks like we need it so we don't need to change something.
			// If we don't do this, the review will be shown twice.
			// return;
		}
		const mainReviewsContainer = mainReviewsWrapper.querySelector('.R-ContentList');
		reviewItems.reverse().forEach((item, index) => {
			item.classList.add('R-ContentList__item--image');
			item.classList.add("InsertedImageContainer");
			mainReviewsContainer.insertBefore(item, mainReviewsContainer.firstChild);
		});
		// console.log('mainReviewsContainer.children', [...mainReviewsContainer.children].slice(TO_SHOW));
		// if(mainReviewsContainer.children.length > TO_SHOW) {
		// 	[...mainReviewsContainer.children].slice(TO_SHOW).forEach((item) => {
				
		// 		item.classList.add('R-ContentList__item--hidden');
		// 	});
		// }
		mainReviewsContainer.children.length > TO_SHOW &&
			[...mainReviewsContainer.children].slice(TO_SHOW).forEach((item, index) => {
				item.classList.add('R-ContentList__item--hidden');
			});
		// remove reviewsWrapperWithImages and the modal
		mainReviewsContainer.children.length > TO_SHOW &&
			[...mainReviewsContainer.children].forEach((item, index) => {
				if (!item.classList.contains('R-ContentList__item--image') && item.querySelectorAll('img').length > 0) {
					item.classList.add('R-ContentList__item--hidden');
				}
			});
		// console.log('item', item);
		document.querySelector('#reviews-io-polaris-modal-ReviewsWidgetimagesource .ElementsWidget')?.remove();
		console.log('reviewsWrapperWithImages', reviewsWrapperWithImages);
		reviewsWrapperWithImages.remove();
		const allItems = [...mainReviewsWrapper.querySelectorAll('.R-ContentList__item')];
		setTimeout(() => {
			setupPaginationButtons(mainReviewsWrapper, allItems, reviewItems.length);
		}, 2000);
	}, 4000);
};

// wait for the reviews to load

const setupPaginationButtons = (mainReviewsWrapper, allItems, imageReviewsCount) => {
	const paginationWrapper = mainReviewsWrapper.querySelector('.R-PaginationControls');
	paginationWrapper.classList.add('R-PaginationControls--old');
	const paginationWrapperCustom = document.querySelector('.R-PaginationControls--custom');
	paginationWrapperCustom?.removeAttribute('hidden');

	paginationWrapperCustom.classList.add('R-PaginationControls--custom');
	// insert the cloned paginationWrapper after the original one
	paginationWrapper.insertAdjacentElement('afterend', paginationWrapperCustom);
	const allButtons = [...paginationWrapperCustom.children];
	paginationWrapperCustom.querySelector('[aria-label="previous"]').addEventListener('click', (event) => {
		const currentPage = parseInt(event.target.dataset.currentPage);
		if (currentPage === 1) {
			return;
		}
		selectPage(allItems, paginationWrapper, currentPage - 1, imageReviewsCount);
		allButtons.forEach((item) => {
			if (item.hasAttribute('current-page')) {
				item.innerHTML = `${currentPage - 1}`;
			}
			item.setAttribute('data-current-page', currentPage - 1);
		});
	});
	paginationWrapperCustom.querySelector('[aria-label="next"]').addEventListener('click', (event) => {
		const currentPage = parseInt(event.target.dataset.currentPage);
		selectPage(allItems, paginationWrapper, currentPage + 1, imageReviewsCount);
		allButtons.forEach((item) => {
			if (item.hasAttribute('current-page')) {
				item.innerHTML = `${currentPage + 1}`;
			}
			item.setAttribute('data-current-page', currentPage + 1);
		});
	});
};
const selectPage = (allItems, paginationWrapper, pageNumber, imageReviewsCount) => {
	const firstReviewIndex = (pageNumber - 1) * TO_SHOW;
	if (firstReviewIndex > imageReviewsCount) {
		allItems.forEach((item) => {
			console.log('item', item);
			if (item.classList.contains('R-ContentList__item--image')) {
				item.classList.add('R-ContentList__item--hidden');
			} else {
				item.classList.remove('R-ContentList__item--hidden');
			}
		});
		const originalPageNumber = pageNumber - Math.round(imageReviewsCount / TO_SHOW);
		const originalLabel = `page${originalPageNumber}`;
		const pageButton = paginationWrapper.querySelector(
			`[aria-label="${originalLabel}"],[aria-label="page${pageNumber}"]`,
		);
		pageButton?.click();
		setTimeout(() => {
			// hide the image reviews from the original page
			allItems
				.filter((item) => !item.classList.contains('R-ContentList__item--image'))
				.forEach((item) => {
					if (item.querySelector('img')) {
						item.classList.add('R-ContentList__item--hidden');
					}
				});
		}, 1000);
	} else {
		allItems.forEach((item, index) => {
			if (index >= firstReviewIndex && index < firstReviewIndex + TO_SHOW) {
				item.classList.remove('R-ContentList__item--hidden');
			} else {
				item.classList.add('R-ContentList__item--hidden');
			}
		});
	}
};
const hideOverallRating = (mainReviewsWrapper) => {
	console.log('hideOverallRating called');
	const overallRatings = mainReviewsWrapper.querySelectorAll('[aria-label="Overall product rating out of 5: "]');
	console.log("overallRatings", overallRatings);
	overallRatings.forEach((item) => {
		const rating = parseFloat(item.innerText);
		if (rating < LOW_RATING_THRESHOLD) {
			item.classList.add('hide');
		}
	});
};
document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		moveImageReviews();
	}, 1000);
});
